import { Pipe, PipeTransform } from '@angular/core';
import { VehicleType } from '../dictonaries/vehicle-type.enum';

@Pipe({
  name: 'vehicleTypeDict'
})
export class VehicleTypeDictPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return VehicleType[ value ];
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pipes/vehicle-type-dict.pipe.ts